import { TextField } from '@mui/material';
import React, { useState } from 'react';

const DateInput = ({ value, onChange, error, helperText, name, label, disabled, onBlur, size }) => {
    const [internalValue, setInternalValue] = useState(value || '');
    const [internalError, setInternalError] = useState('');

    const isValidDate = (year, month, day) => {
        if (year < 1920) return false;
        if (month < 1 || month > 12) return false;
        const daysInMonth = new Date(year, month, 0).getDate();
        if (day < 1 || day > daysInMonth) return false;
        return true;
    };

    const handleInputChange = (e) => {
        const input = e.target.value;
        let error = false
        let errorText = ''
        const numericInput = input.replace(/\D/g, '');
        const year = numericInput.substring(0, 4);
        const month = numericInput.substring(4, 6);
        const day = numericInput.substring(6, 8);

        if (numericInput.length > 8) return;

        let formattedInput = '';
        if (year) formattedInput += year;
        if (month) formattedInput += `-${month}`;
        if (day) formattedInput += `-${day}`;

        if (numericInput.length === 8) {
            const yearNum = parseInt(year, 10);
            const monthNum = parseInt(month, 10);
            const dayNum = parseInt(day, 10);

            if (!isValidDate(yearNum, monthNum, dayNum)) {
                setInternalError('Fecha inválida. Verifica el año, mes o día.');
                error = true
                errorText = 'Fecha inválida. Verifica el año, mes o día.'
            } else {
                setInternalError('');
                error = false
                errorText = ''
            }
        } else {
            setInternalError('');
            error = false
            errorText = ''
        }
        setInternalValue(formattedInput);
        onChange({ target: { name: name, value: formattedInput }, error, errorText });
    };

    
    const handleBlur = () => {
        let error = false
        let errorText = ''
        const numericInput = internalValue.replace(/\D/g, '');


        if (numericInput.length === 8) {
            console.log("estoy aqui")
            const year = parseInt(numericInput.substring(0, 4), 10);
            const month = parseInt(numericInput.substring(4, 6), 10);
            const day = parseInt(numericInput.substring(6, 8), 10);

            if (!isValidDate(year, month, day)) {
                setInternalError('Fecha inválida. Verifica el año, mes o día.');
                error = true
                errorText = 'Fecha inválida. Verifica el año, mes o día.'
            } else {
                setInternalError('');
                error = false
                errorText = ''
            }
        }
        else if (numericInput.length === 0) {
            setInternalError('La fecha es obligatoria.');
            error = true
            errorText = 'La fecha es obligatoria.'
        } else if (internalValue.length > 0) {
            console.log("estoy haya")

            setInternalError('Formato incorrecto. Usa YYYY-MM-DD.');
            error = true
            errorText = 'Formato incorrecto. Usa YYYY-MM-DD.'
        } else {

            setInternalError('');
            error = false
            errorText = ''
        }
        onBlur({ name: name, error, errorText });

    };


    return (
        <TextField
            fullWidth
            label={label}
            name={name}
            value={internalValue}
            size={size || 'medium'}
            disabled={disabled === undefined ? false : disabled}
            onChange={handleInputChange}
            onBlur={handleBlur}
            error={!!error || !!internalError}
            helperText={internalError || helperText}
            placeholder="YYYY-MM-DD"
            variant="outlined"
        />
    );
};

export default DateInput;